import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { ClassicType } from '../../shared/models/ClassicType';
import { Progetto } from '../Models/Progetto';
import { ProgettiStoreService } from '../_services/progetti-store.service';
import { ApiRestService } from '../_services/api-rest.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {Component, Input, OnInit} from '@angular/core';
import { ServerPaginationService } from 'src/app/shared/_services/server-pagination.service';
import { ActivatedRoute, Router } from '@angular/router';
import {Subject, Subscription} from 'rxjs';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import {Color, hsl, xml} from 'd3';
import {Permission} from "../../Login/_guards/Permission";
import {ToastrService} from "ngx-toastr";
import {ApiPathsService} from "../../api-paths.service";
import {debounceTime} from "rxjs/operators";
import {RmaEditComponent} from "../../rma/rma-edit/rma-edit.component";
import {ImportModalComponent} from "../Import Modal/import-modal";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-lista-progetti',
  templateUrl: './lista-progetti.component.html'
})
export class ListaProgettiComponent implements OnInit {
  @Input() cliente: string = undefined;
  @Input() hasHeader: boolean = true;
  subscriptions: Subscription = new Subscription();
  environment = environment;
  collectionSize = 0;
  showAllText = "Mostra Eliminati";
  showAll: boolean = false;
  FilterForm: FormGroup;
  submitted: boolean;
  titolo = "menu.ProgettiLabel";
  VersioneCarbotti= environment.Modules['VersioneCarbotti'];
  stato: string;
  badges: any = {};
  Tipo: any;
  private editorUrl: string;
  get f() { return this.FilterForm.controls; }
  ProgettoSelezionato: Progetto;
  Progetti: Progetto[] = [];
  stati: ClassicType[] = [];
  statiSelezionati: ClassicType[] = [{id:"T", label:"Tutti"}];
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    textField: 'label',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: false,
    allowRemoteDataSearch: true,
  };
  public debouncedInputValue = null;
  private searchDecouncer$: Subject<any> = new Subject();
  /**************************************
         Variabili paginazione
   **************************************/
  page = 1;
  pageSize = 50;
  pagesizeserver = 4 // pagine da precaricare da lserver
  newpagegenerated = 1; // pagina per cui è stata fatta la richiesta al server
  today = new Date();
  inizioMese = new Date(this.today.getFullYear(), 0, 1);
  fineMese = new Date(this.today.getFullYear(),  12, 0) ;
  filter = {page: 1, size: this.pagesizeserver * this.pageSize, cliente: undefined, stato_prog: 'T' ,periodo: true, inizio: this.datepipe.transform( this.inizioMese,'yyyy-MM-dd'), fine: this.datepipe.transform( this.fineMese,'yyyy-MM-dd'), orderByCodice: undefined, orderByName: undefined, orderByData: undefined, orderByCliente: undefined, oldrev: false, annullati: false};
  hide: Boolean = false;

  constructor(
    private paginationService: ServerPaginationService,
    private apirestservice: ApiRestService,
    private progettiStore: ProgettiStoreService,
    private route: ActivatedRoute,
    private router: Router,
    private datepipe: DatePipe,
    public permission: Permission,
    private toastrService: ToastrService,
    private apiPaths: ApiPathsService,
    private modalService: NgbModal
  ) {

  }

  ngOnInit() {
    this.route.params.subscribe(data => {
      this.stato = data['status'];
      this.Tipo = data['tipo'];
      this.refreshTable(1);
      this.editorUrl = this.Tipo? `progetti/ordine/${this.Tipo}`: `progetti/progetto`
    } )
    this.progettiStore.getStatiProgetto();
    this.subscriptions.add(this.progettiStore.$showAllProgetti.subscribe(x => this.showAll = x));
    this.subscriptions.add(this.progettiStore.$statiProgetto.subscribe(x => this.stati = x));
    this.subscriptions.add(this.progettiStore.$progetti.subscribe(x => {
      if (x && x != null) {
        this.collectionSize = x.total;
        this.badges = x;
        this.badges.Accettate = x.total - (x['chiuse'] ?? 0) - (x['annullate'] ?? 0) - (x['nonAccettate'] ?? 0) ;
        console.log(x);
        this.Progetti = x.data.filter(x=> this.cliente && x?.clienteObject?.nominativo == this.cliente || !this.cliente);
      }
    }));
    this.setupSearchDebouncer();

  }


  hasManager(){
    return this.Progetti.some(item=> item?.agenteObject?.fullName ?? item?.managerObject?.fullName)
  }

  BadgeColor(item: Progetto){
    var colore = item.colore;
    environment.ProgettiAddon['ColoriLista']?.forEach(color=>{
      if(item[color.campo])
        colore = color.colore;
    });
    return colore ?? '#ffffff';
  }

  add() {
    this.progettiStore.updateEditable(false);
    this.progettiStore.updateShowAddForm(true);
    this.router.navigate([this.route.snapshot.queryParams[this.editorUrl] || this.editorUrl,])
   }
  edit(item: Progetto) {
      //this.progettiStore.updateProgettoSelezionato(item);
      this.progettiStore.updateEditable(true);
      this.progettiStore.updateShowAddForm(false);
      var url = `${this.editorUrl}/${item?.id?.toString() ?? ''}`
      this.router.navigate([this.route.snapshot.queryParams[url] || url,])
  }
  delete(item: Progetto) {
    if (confirm("Sei sicuro di voler eliminare questo elemento?")) {
      if (item.enabled) {
        this.apirestservice.softDeleteProgetti(item).subscribe(
          () => this.refreshTable(this.newpagegenerated)
        );
      } else {
        this.apirestservice.hardDeleteProgetti(item).subscribe(
          () => this.refreshTable(this.newpagegenerated)
        );
      }
    }
   }
  renew(item: Progetto) {
    this.apirestservice.restoreProgetti(item).subscribe(
      () => this.refreshTable(this.newpagegenerated)
    );
  }

  sizeChanged() {
    this.pageSize = parseInt(this.f.size.value);
    this.refreshTable(1);
  }

  public onSearchInputChange(): void {
    this.searchDecouncer$.next(this.filter);
  }

  private setupSearchDebouncer(): void {
    this.searchDecouncer$.pipe(
      debounceTime(1250),
      //distinctUntilChanged(),
    ).subscribe((term: any) => {
      this.debouncedInputValue = term;
      console.log('debouncedInputValue', term)
      this.refreshTable(1, term);
    });
  }

  Search() {
    this.onSearchInputChange()
  }
  showDeleted() {
    this.progettiStore.updateShowAllProgetti(!this.showAll);
    this.refreshTable(1);
    if (this.showAll) {
      this.showAllText = "Nascondi eliminati";
    } else {
      this.showAllText = "Mostra eliminati";
    }
  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refreshTable(pagetosend);
    }
  }
  refreshTable(page: number, filters?:any) {
    this.filter = filters ?? this.filter;
    this.filter.page = (page - 1) / this.pagesizeserver + 1;
    this.filter.size = this.pagesizeserver * this.pageSize;
    this.filter.cliente = this.cliente ?? this.filter.cliente;
    this.filter.stato_prog = this.stato ?? ( this.statiSelezionati?.length > 0 ? this.statiSelezionati[0]?.id : "T");
    if (!this.showAll)
      this.progettiStore.getProgetti(this.filter, this.Tipo? environment.ProgettiAddon['TipiProgetto']?.find(x=> x.id == this.Tipo )?.restRoute : null);
    else
      this.progettiStore.getAllProgetti(this.filter, this.Tipo? environment.ProgettiAddon['TipiProgetto']?.find(x=> x.id == this.Tipo )?.restRoute : null);
  }
  LightenColor(color: Color, percent = 50) {
    var num = parseInt(color.toString().replace("#", ""), 16);
    if (num < 10000000)
      return hsl(0, 0, 100);
    else
      return hsl(0, 0, 0);
};

  Filtra(orderBy: string) {
    var ordiniGestiti = ['orderByCliente', 'orderByName', 'orderByCodice', 'orderByData' ]
    if(!ordiniGestiti.includes(orderBy)) return;
    this.filter[orderBy] = this.filter[orderBy] == 'desc' || !this.filter[orderBy] ? 'asc' : 'desc';
    ordiniGestiti.forEach(element=> this.filter[element] = element == orderBy ? this.filter[element] : undefined);
    this.refreshTable(this.newpagegenerated);


  }

  PrendiInCarico(item: Progetto) {
    if(confirm("Sei sicuro di voler prendere in carico Questa offerta?"))
      this.apirestservice.PrendiinCarico({id:item.id}).subscribe(()=>{
        this.refreshTable(this.newpagegenerated);
      });
  }

  customButton(button: { type?: 'GET'| 'POST', restRoute?: string, preMex?: string, successMex?: string, campi: any[], nome:string}) {
    if(button.preMex)
      this.toastrService.warning(button.preMex);
    if(button.type == 'GET' && button.restRoute)
      this.apiPaths.ClassicGet(button.restRoute).subscribe(data=>{
        if(button.successMex)
          this.toastrService.success(button.successMex);
        this.refreshTable(1);
      })
    if(button.type == 'POST' && button.campi && button.restRoute) {
      const editmodal = this.modalService.open(ImportModalComponent, {
        centered: true,
        backdrop: 'static',
        size: 'xl',
      });
      (<ImportModalComponent>editmodal.componentInstance).RestRoute = button.restRoute;
      (<ImportModalComponent>editmodal.componentInstance).Campi = button.campi;
      (<ImportModalComponent>editmodal.componentInstance).successMex = button.successMex;
      (<ImportModalComponent>editmodal.componentInstance).Title = button.nome;
      (<ImportModalComponent>editmodal.componentInstance).onImport.subscribe((res)=>{
        this.refreshTable(1);
      })
    }

  }
}
